const documents = {
    noDocuments: "No existen documentos",  
    prompt: 'Instrucción' 
}

export default documents;